
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Headerpage from "src/components/header";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { Redirect, withRouter } from 'react-router-dom';
import Footerpage from "src/components/footer";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = IAxiosProps & IAppContext &
  WithStyles<keyof ReturnType<typeof styles>>&{history:any};

interface ITemplatesPageState {
  mascot: any
  mascotErr: any
  loader: boolean;
  redirect: boolean,
  schools:any

}

const Home = withStyles(styles)(
  withAxios(
    class LeadPage extends Component<IProps, ITemplatesPageState> {
      public state = this.buildState({
        mascot: '',
        mascotErr: '',
        loader: false,
        redirect: false,
        schools:[]
      });

      public componentDidMount() {
        this.setState({ redirect: false })
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.props?.newUserDetails?.mascot) {
          this.setState({ mascot: this.props.newUserDetails.mascot })
        }
        this.getAllSlug()

      }
      public async getAllSlug() {
        const AllSchoolSlug: any = await this.buildGet(
          this,
          `school/getAllSchoolSlug`
        )();
        console.log("getAllSchoolSlug==========>", AllSchoolSlug?.data);
        if (AllSchoolSlug?.data?.length > 0) {
          this.setState({ schools: AllSchoolSlug?.data.map((itm:any)=>itm?.slug?.toLowerCase()) })
        }
      }
      public componentWillMount(){
        this.props.getNewLoginUserDetails()
      }
      public nextHandler() {
       
        this.setState({ mascotErr: '', })
        const { mascot } = this.state
        if (mascot !== "") {
          this.props.onChangeUserDetails({ ...this.props?.newUserDetails, mascot })
          // this.setState({ redirect: true })
          this.props.history.push("/price")
        } else {
          if (mascot === "") {
            this.setState({ mascotErr: 'Mascot is required' })
          }
        }
       
      }

      public render() {
        return (
          <>
            {this.state.redirect && <Redirect to="/price" />}
            {/* <div className="header"> */}
            <Headerpage/>
            {/* </div> */}
            <div className="container-inner">
              <div className=" content-leader"
                style={{
                  width: "100%",
                  height: "calc(100vh - 153px)",
                  backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/homepage_img.jpg')})`,
                  backgroundPosition: 'center'
                }}>

                <div className="welcome-backs">
                  <div className="sign-In-backs school-inner">
                    <h1><span> What is </span><span  className="truncate">{this.props?.newUserDetails?.schoolOrganization}</span><span>'s mascot?</span></h1>
                  
                    <form className="next3-form">
                      <div className="input-flex">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                          <input type="text" className="form-control lead-inner" placeholder="Eagles, Falcons or others"
                            value={this.state.mascot}
                            onChange={(event) => {
                              this.setState({ mascot: event.target.value })
                            }}
                          />
                          {this.state.mascotErr !== "" && <div className="span-error" style={{ color: 'red' }}>{this.state.mascotErr}</div>}
                        </div>
                      </div>

                    </form>

                    <button className="sign-btn" onClick={() => {
                      this.nextHandler()
                    }}><span className="next-span-btn">NEXT</span></button>
                  </div>
                </div>

              </div>

            </div>
           <Footerpage/>



          </>
        );
      }
    }
  )
);



const HomeFunction = (props:any) => (
  <AppContextConsumer>{(context) => <Home {...context}  history={props?.history}/>}</AppContextConsumer>
);
export default withRouter(HomeFunction);





// WEBPACK FOOTER //
// ./src/pages/home/Lead/lead.tsx